import { request } from './config/utils'

import { Params } from '../../constants'

export function loginPostRequest(params) {

    return request('post', params, Params.LOGIN_POST)
}

export function updatePasswordPostRequest(params) {

    return request('post', params, Params.UPDATE_PASSWORD_POST)
}